import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  IconButton,
  Snackbar,
  Alert,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const ChangePassword = () => {
  const [username, setUsername] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const navigate = useNavigate();

  const handleClose = () => {
    navigate("/users");
  };

  const handleUpdate = async () => {
    // Validation messages
    if (!username && !newPassword) {
      setSnackbar({
        open: true,
        message: "Username and password are required.",
        severity: "warning",
      });
      return;
    } else if (!username) {
      setSnackbar({
        open: true,
        message: "Username is required.",
        severity: "warning",
      });
      return;
    } else if (!newPassword) {
      setSnackbar({
        open: true,
        message: "Password is required.",
        severity: "warning",
      });
      return;
    }

    try {
      const response = await axios.put(
        "https://d3ioa5kdb9.execute-api.ap-south-1.amazonaws.com/Tis_whatsapp_be/password",
        {
          username,
          password: newPassword,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.status === 200) {
        setSnackbar({
          open: true,
          message: "✅ Password updated successfully!",
          severity: "success",
        });
        setUsername("");
        setNewPassword("");
        setTimeout(() => navigate("/users"), 2000);
      } else {
        setSnackbar({
          open: true,
          message: response?.data?.message || "❌ Failed to update password.",
          severity: "error",
        });
      }
    } catch (error) {
      console.error("API error:", error);
      let message = "❌ Failed to update password.";
      if (error.response) {
        message =
          error.response.data?.message ||
          `Error ${error.response.status}: ${error.response.statusText}`;
      } else if (error.request) {
        message = "No response from server. Check your network.";
      }

      setSnackbar({ open: true, message, severity: "error" });
    }
  };

  return (
    <Box
      sx={{
        width: 400,
        mx: "auto",
        mt: 4,
        p: 3,
        borderRadius: 2,
        boxShadow: 1,
        backgroundColor: "#fff",
        position: "relative",
      }}
    >
      {/* Close Button */}
      <IconButton
        onClick={handleClose}
        sx={{ position: "absolute", top: 8, right: 8, color: "gray" }}
      >
        <CloseIcon />
      </IconButton>

      <Typography
        variant="subtitle1"
        sx={{ fontWeight: "bold", mb: 2, color: "#1a237e" }}
      >
        Change Password
      </Typography>

      <Typography variant="body2" sx={{ mb: 0.5 }}>
        Username:
      </Typography>
      <TextField
        fullWidth
        placeholder="Enter username"
        size="small"
        variant="outlined"
        sx={{ mb: 2 }}
        value={username}
        onChange={(e) => setUsername(e.target.value)}
      />

      <Typography variant="body2" sx={{ mb: 0.5 }}>
        New password:
      </Typography>
      <TextField
        fullWidth
        placeholder="Enter new password"
        type="password"
        size="small"
        variant="outlined"
        sx={{ mb: 3 }}
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
      />

      <Button
        variant="contained"
        onClick={handleUpdate}
        sx={{
          background: "linear-gradient(to right, #0052D4, #4364F7, #6FB1FC)",
          color: "#fff",
          textTransform: "none",
          fontWeight: "bold",
          borderRadius: 2,
          py: 1,
          fontSize: "1rem",
          boxShadow: "0 4px 12px rgba(0, 82, 212, 0.4)",
          transition: "all 0.3s ease",
          "&:hover": {
            transform: "scale(1.03)",
            boxShadow: "0 6px 16px rgba(67, 100, 247, 0.5)",
            background: "linear-gradient(to right, #003cbd, #3451e0, #5e96f5)",
          },
        }}
      >
        🚀 Update
      </Button>

      {/* Snackbar for feedback */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert
          severity={snackbar.severity}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          variant="filled"
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default ChangePassword;
